import { useMutation } from '@tanstack/react-query';

type UpdateCompanyProfileParams = {
  companyId: number;
  name?: string;
  organization_user_ids?: number[];
  custom_data?: Array<{
    field_id: number;
    content: string;
  }>;
  company_information?: {
    description?: string;
    president_name?: string;
    official_url?: string;
    address?: string;
    established_date?: string;
    phase?: string;
    listed_phase?: string;
    number_of_employees?: number | null;
    industry_id?: number;
    corporate_number?: string;
    open_info?: string;
  };
  company_contract?: {
    contract_status?: string;
    fee_rate?: number;
    minimum_fee?: number;
    note?: string;
  };
};

export default function useUpdateCompanyProfile() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async (params: UpdateCompanyProfileParams) => {
      const { companyId, ...bodyParams } = params;

      const response = await fetch(`/agent/api/companies/${companyId}`, {
        method: 'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify(bodyParams),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.errors?.join(', ') || 'Update failed');
      }

      const data = await response.json();
      return data;
    },
  });
}
